import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  static targets = ["nav", "content"]

  connect() {
    this.updateLayout();
  }

  showIconSearch(event) {
    event.preventDefault();
    this.activateTab(event.currentTarget);
    this.showIconSearchTab();
  }

  showMediaLibrary(event) {
    event.preventDefault();
    this.activateTab(event.currentTarget);
    this.hideNavAndExpandContent();
  }

  showUpload(event) {
    event.preventDefault();
    this.activateTab(event.currentTarget);
    this.hideNavAndExpandContent();
  }

  showIconSearchTab() {
    this.navTarget.classList.remove('hidden');
    this.contentTarget.classList.remove('expanded');
  }

  hideNavAndExpandContent() {
    this.navTarget.classList.add('hidden');
    this.contentTarget.classList.add('expanded');
  }

  activateTab(tabElement) {

    this.element.querySelectorAll('ul.tabs li.tab-title').forEach(tab => {
      tab.classList.remove('active');
    });

    tabElement.parentElement.classList.add('active');
  }

  updateLayout() {
    const activeTab = this.element.querySelector('ul.tabs li.tab-title.active a');
    if (activeTab) {
      const href = activeTab.getAttribute('href');
      if (href === '#paicons') {
        this.showIconSearchTab();
      } else {
        this.hideNavAndExpandContent();
      }
    }
  }
}
